// extracted by mini-css-extract-plugin
module.exports = {"finalStep":"SuccessScreen_finalStep__ENcpU","logo":"SuccessScreen_logo__32ETs","content":"SuccessScreen_content__mITS_","button":"SuccessScreen_button__vgwTD"};